import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    YES: {
        id: 'ase.priorityTreatment.option.yes',
        defaultMessage: 'Yes'
    },
    NO: {
        id: 'ase.priorityTreatment.option.no',
        defaultMessage: 'No'
    },
});

export default messages;
